export default {
    'INSERIR_PAISES' (state, payload) {
        state.paises = payload;
    }
};
